export const environment = {
    production: true,
    shoppingApi: 'https://pricing-api.api.trueaccess.care',
    name: 'production',
};
